export const generalOncologyConst = {
  path: "/single-programs/general-oncology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ОБЩАЯ ОНКОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Онкология — борьба за жизнь и надежду</h2>
      <p>
        Онкология — это ключевое направление современной медицины, сосредоточенное на диагностике, лечении и профилактике злокачественных
        новообразований. Это одна из самых сложных и быстроразвивающихся областей, в которой сочетаются высокотехнологичные методы,
        клиническое мышление и глубокое понимание человека.
      </p>
      <p>
        Программа охватывает широкий спектр знаний: от молекулярной биологии опухолей до современных протоколов химио- и лучевой терапии.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Онкогенез и молекулярные механизмы рака</li>
        <li>Методы ранней диагностики и скрининга</li>
        <li>Онкохирургия и минимально инвазивные вмешательства</li>
        <li>Химиотерапия, таргетная и иммунотерапия</li>
        <li>Радиотерапия и современные методы облучения</li>
        <li>Паллиативная помощь и психоонкология</li>
        <li>Медицинская этика в онкологии</li>
        <li>Клинические исследования и доказательная практика</li>
      </ul>
      <p>
        Практическая подготовка включает стажировки в онкоцентрах, участие в клинических консилиумах и научно-исследовательских проектах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Онколог в государственных и частных клиниках</li>
        <li>Химиотерапевт или специалист по таргетной терапии</li>
        <li>Радиолог или врач лучевой терапии</li>
        <li>Врач паллиативной помощи и поддержки</li>
        <li>Специалист по онкодиагностике</li>
        <li>Исследователь в области онкобиологии</li>
        <li>Преподаватель, эксперт или клинический консультант</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Онкологи — одни из самых востребованных врачей в Европе.</p>
      <p>
        <strong>Средний доход составляет от €70,000 до €130,000 в год,</strong> с возможностью международной карьеры.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом магистра с международным признанием</li>
        <li>Возможность учебы на русском или английском языке</li>
        <li>Гибкая форма: очно или дистанционно</li>
        <li>Современное оборудование и доступ к клиническим базам ЕС</li>
        <li>Акцент на практику и участие в мультидисциплинарных командах</li>
        <li>Поддержка трудоустройства и индивидуальное сопровождение студента</li>
      </ul>
      <h2>Учёба, которая делает жизнь людей качественнее</h2>
      <p>Наши выпускники — это профессионалы, ежедневно помогающие пациентам справляться с самым трудным диагнозом.</p>
      <br />
      <p className="padding-left">«Онкология — это не только лечение, это наука о жизни, надежде и человеческом достоинстве.»</p>
      <h2>Как поступить?</h2>
      <p>Оставьте заявку, чтобы узнать подробности поступления, сроки и стоимость обучения.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Онкология — борьба за жизнь и надежду
    Онкология — это ключевое направление современной медицины, сосредоточенное на диагностике, лечении и профилактике злокачественных новообразований. Это одна из самых сложных и быстроразвивающихся областей, в которой сочетаются высокотехнологичные методы, клиническое мышление и глубокое понимание человека.
    Программа охватывает широкий спектр знаний: от молекулярной биологии опухолей до современных протоколов химио- и лучевой терапии.

    Что вы будете изучать?
    • Онкогенез и молекулярные механизмы рака
    • Методы ранней диагностики и скрининга
    • Онкохирургия и минимально инвазивные вмешательства
    • Химиотерапия, таргетная и иммунотерапия
    • Радиотерапия и современные методы облучения
    • Паллиативная помощь и психоонкология
    • Медицинская этика в онкологии
    • Клинические исследования и доказательная практика
    Практическая подготовка включает стажировки в онкоцентрах, участие в клинических консилиумах и научно-исследовательских проектах.


    Кем можно работать после окончания?
    • Онколог в государственных и частных клиниках
    • Химиотерапевт или специалист по таргетной терапии
    • Радиолог или врач лучевой терапии
    • Врач паллиативной помощи и поддержки
    • Специалист по онкодиагностике
    • Исследователь в области онкобиологии
    • Преподаватель, эксперт или клинический консультант

    Востребованность и доход
    Онкологи — одни из самых востребованных врачей в Европе.
    Средний доход составляет от €70,000 до €130,000 в год, с возможностью международной карьеры.

    Почему выбирают нас?
    • Европейский диплом магистра с международным признанием
    • Возможность учебы на русском или английском языке
    • Гибкая форма: очно или дистанционно
    • Современное оборудование и доступ к клиническим базам ЕС
    • Акцент на практику и участие в мультидисциплинарных командах
    • Поддержка трудоустройства и индивидуальное сопровождение студента


    Учёба, которая имеет значение
    Наши выпускники — это профессионалы, ежедневно помогающие пациентам справляться с самым трудным диагнозом.
    «Онкология — это не только лечение, это наука о жизни, надежде и человеческом достоинстве.»

    Как поступить?
    Оставьте заявку, чтобы узнать подробности поступления, сроки и стоимость обучения. 
  `,
};
